export default __webpack_public_path__ + "static/media/reachit.14fc4640.png";